module.exports = __webpack_public_path__ + "img/img_thumb.033bac4b.jpg";